var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"alert"},[_vm._v("Are you sure?")]),_c('br'),_c('button',[_c('div',{on:{"click":function($event){return _vm.logOut()}}},[_vm._v("YES")])])])}
var staticRenderFns = []

export { render, staticRenderFns }